// extracted by mini-css-extract-plugin
module.exports = {"new_main_page_record_modal_wrapper":"RecordModal_new_main_page_record_modal_wrapper__28Fiu"};